import { render, staticRenderFns } from "./SliderInput.vue?vue&type=template&id=4ff07175&scoped=true&"
import script from "./SliderInput.vue?vue&type=script&lang=js&"
export * from "./SliderInput.vue?vue&type=script&lang=js&"
import style0 from "./SliderInput.vue?vue&type=style&index=0&id=4ff07175&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff07175",
  null
  
)

export default component.exports